import { Pipe, PipeTransform } from '@angular/core';
import { IFormField } from '@appgen-health-crm/api-interfaces';

// this pipe will call the function only once instead of calling it each time change detection happens
@Pipe({
  name: 'otherFieldsByType',
  pure: true
})
export class OtherFieldsByTypePipe implements PipeTransform {
  transform(
    currField: IFormField,
    allFields: IFormField[],
    type: string
  ): IFormField[] {
    return allFields
      .filter(x => x.type === type && x.name !== currField.name)
      .map(x => ({ ...x }));
  }
}
